import { createBrowserRouter } from 'react-router-dom'

import { privateRoutes } from './privateRoutes'
import { pubicRoutes } from './publicRoutes'

/**
 * The return type is used to avoid ts complaining about the type of the router
 * https://github.com/remix-run/react-router/issues/10787#issuecomment-2188170250
 */
export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  ...pubicRoutes,
  ...privateRoutes,
])
